import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {LuminizerRoutes} from '../../shared/interfaces/routes';
import {AuthorizationService} from '../../shared/services/authorization/authorization.service';

export const controlV2Guard: CanActivateFn = () => {
    const authorizationService = inject(AuthorizationService);
    const router = inject(Router);

    return authorizationService.useNewControlUiUx()
        ? true
        : router.createUrlTree(['/', LuminizerRoutes.FORBIDDEN_PAGE]);
};